import type {
    ActionCreatorWithoutPayload,
    ActionCreatorWithPayload,
    ActionCreatorWithPreparedPayload,
} from '@reduxjs/toolkit';
import * as R from 'ramda';

import { actionBinder } from './actionBinder';
import type { Meta } from './types';

/**
 * Create an object with action creators as first arg but with params in meta field of returned value
 *
 * @param actions - object with action creators by name
 * @param id - param to add in meta of returned action
 * @param metaKey - key to add in meta of returned action
 */
export function createBoundActions<
    A extends {
        [key in string]:
            | ActionCreatorWithPayload<any>
            | ActionCreatorWithPreparedPayload<any, any>
            | ActionCreatorWithoutPayload;
    },
    N extends keyof A,
>(
    actions: A,
    id: string,
    predefinedMeta?: Meta,
): {
    [K in N]: ActionCreatorWithPreparedPayload<Parameters<A[K]>, ReturnType<A[K]>['payload'], string, never, Meta>;
} {
    return R.map((action) => actionBinder(action, id, predefinedMeta), actions);
}
